import React, {useEffect, useCallback, useState, useContext, useRef} from "react";

// Page Components
import ObjectRentals from "../../components/UI Components/ObjectList/Object/Object_rentals";
import MessageToast from "../../components/UI Components/Messages/MessageToast";

// Router:
import { useNavigate } from 'react-router';

// MUI Components:
import Box  from '@mui/material/Box';
import Container from "@mui/material/Container";
import CircularProgress from '@mui/material/CircularProgress';

// utils
import {createURLQuery} from '../../utility/utils';

// custom hooks
// import useScreenSize from '../../custonHooks/useScreenSize';

// Theme
import { useTheme } from '@mui/material/styles';

// translation:
import { useTranslation } from 'react-i18next';

// Context
import { FilterContext, useFilterDispatch,useFilter } from "../../Context/FilterCountext";
import { ObjListContext, ObjListDispatchContext, useObjList, useObjListDispatch } from "../../Context/ObjectListContext";
import {useAuthData} from '../../Context/AuthContext';

// model
import {_getObjects} from '../../models/model';


function Home({onObjDetailPress}) {

    console.log("RENDER HOME");

    const { t, i18n }  = useTranslation(),
        theme          = useTheme(),
        observer       = useRef();

    const filterDispatch  = useFilterDispatch(),
          objListDispatch = useObjListDispatch(),
          objectList      = useObjList(),
          filterSetting   = useFilter(),
          authData        = useAuthData(),
          navigate        = useNavigate();
        //   screenSize      = useScreenSize();

    const [aRentals, setRentals]       = useState([]);
    const [isHomeBusy, setHomeBusy]    = useState(false);


    // to be converted to custom hook(reusable )
    const lastRentRef = useCallback(node => {

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver( async entries => {
        if (entries[0].isIntersecting && objectList.hasMore ) {
           await objListDispatch({ type: 'incrPage', data: null });
           await filterDispatch({ type:'upd_reason', reason : 'load' }); 
        }
        });

        if (node) observer.current.observe(node);   

        }, [objectList.hasMore, objListDispatch,filterDispatch]);

    useEffect( () => {

        // console.log(screenSize, "from home- fetch")

        const fetchRentals = async() => {
            let oResp, 
                oURLQuery;

            try {           
                // IN Case the action has been triggered from filterView Fragment. 
                // then terminate. The data fetch call will be called from the FilterView Event
                if(filterSetting.reason === 'filter') { 
                    return; 
                }

                setHomeBusy(true);

                oResp  = await _getObjects('rnt',filterSetting, objectList.page);
                         await objListDispatch({ type: 'setList', data: oResp, reason:'load'});
                         await filterDispatch({ type:'setCount', resultCount : oResp.result.length });

                setHomeBusy(false);

            } catch(e) {
                alert('Technical Error. Failed to load Data');
                setHomeBusy(false);
            }

        }

        fetchRentals(); 

        // if(authData.isAuthenticated) {
        //     fetchRentals(); 
        // } else {
        //     navigate('/login');
        // }
        

    },[objectList.page,objListDispatch,filterSetting,filterDispatch]) //authData




    return(
        <Container>
            {              
            <Box sx={{ display:"flex", 
                    justifyContent:'space-between',
                    flexDirection:{xs:'column', md:'row'}, 
                    flexWrap:{sx:'nowrap',md:'wrap',lg:'wrap',xl:'wrap'}}}>
                {   
                objectList['data'].map( (oItem, index) => {

                     
                    if(index === objectList['data'].length - 1) {
                        return(
                            // key={`${oItem._id}-cntnr`}
                            <Box key={`${oItem._id}-${index}`} ref={lastRentRef} sx={{ maxWidth:{md:'45%',lg:'45%',xl:'45%'} }} >
                                <ObjectRentals
                                    // key={`${oItem._id}-rntobj`} 
                                    oObject={oItem}
                                    onObjDetailPress={onObjDetailPress}/>
                            </Box>
                        )
                    } else {
                        return(
                            // key={`${oItem._id}-cntnr`}
                            <Box key={`${oItem._id}-${index}`} sx={{ maxWidth:{md:'45%',lg:'45%',xl:'45%'} }}>
                                <ObjectRentals
                                    // key={`${oItem._id}-rntobj`} 
                                    oObject={oItem}
                                    onObjDetailPress={onObjDetailPress}/>
                            </Box>
                        )                     
                    }

                    })
                }

                <Box sx={{position:'relative', zIndex:3}} display={isHomeBusy ? "flex" : "none"} justifyContent={"center"} width={'100%'}>
                    <CircularProgress sx={{position:'absolute'}} color={theme.palette.main}/>         
                </Box>
            </Box>

            }
        </Container>


    )
}
export default Home;


// out scoped:

    // const fetchRentals_old = useCallback( async () => {
    //     try {

    //     setHomeBusy(true);
    //     // const api_ge_url  = process.env.REACT_APP_API_GW_DEV_URL;
    //     // const sPath        = api_ge_url + "/products";

    //     // local:
    //     const localePath =  "/rentals/homes";
    
    //     const srvResponse = await fetch(localePath);
    //     const data        = await srvResponse.json();

    //     // let sortedData    = data.sort((a,b) => b.prod_id.localeCompare(a.prod_id));
    //     setRentals(data);
    //     // setListLength(data.length);
    //     oFilterContext.updateRsltCount(data.length);
    //     setHomeBusy(false)

    //     } catch(e) {
    //         console.log(e);
    //         alert('error could not fetch');
    //     }
    // },[])

    
    // default sort by date
    // oURLQuery =  createURLQuery({type: 'dat'});
    // data      = await _getObjects('rnt',{}, oURLQuery);



        // const fetchRentals = useCallback( async () => {

    //     let oResp, 
    //         oURLQuery;

    //     try {

    //         setHomeBusy(true);
    //             console.log(objectList);
    //         oResp  = await _getObjects('rnt',filterSetting, pageIndex);
    //                  await objListDispatch({ type: 'setList', data: oResp });
    //                  await filterDispatch({ type:'setCount', resultCount : oResp['result'].length });

    //         setHomeBusy(false);

    //     } catch(e) {
    //         alert('Technical Error. Failed to load Data');
    //         setHomeBusy(false);
    //     }
    // },[filterDispatch,filterSetting,objListDispatch])

    // useEffect(() => { 
    //     fetchRentals(); 
    // },[]);